import { render, staticRenderFns } from "./import-question.vue?vue&type=template&id=40a8c3e4&scoped=true&"
import script from "./import-question.vue?vue&type=script&lang=ts&"
export * from "./import-question.vue?vue&type=script&lang=ts&"
import style0 from "./import-question.vue?vue&type=style&index=0&id=40a8c3e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a8c3e4",
  null
  
)

export default component.exports